module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_okunaiteien-ecc96992b3c97a74753706b63da2648a.jpg";